angular.module("ainapp")
    .controller("generalLedgerPDCController", ["app.config", "$scope", "$http", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", function (config, $scope, $http, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

        $scope.init = function () {

            $scope.selectAllAccRows = false;
            $scope.Load = false;
            $scope.Error = 0;
            $scope.FromDateObject = null;
            $scope.ToDateObject = null;

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.filter = {
                AccountMasterId: "",
                FromDate: $scope.d2,
                ToDate: new Date(),
                IsFilter: false,
                DocNo: "",
                CostCenter1Id: "",
                CostCenter2Id: "",
                CostCenter3Id: "",
            }

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.filter.FromDate = new Date($scope.finyear.StartDate);
            });

            $scope.AccFilter = {
                Keyword: "",
            }
            $scope.selectAll = false;

            $scope.GlLoad = false;
            $scope.AccLoad = true;
            $scope.Accounts = [];
            MainService.AccountList().then(function (response) {
                $scope.Accounts = response.data;
                $scope.AccLoad = false;
            });

            $scope.SelectedAccounts = [];
            $scope.GlData = [];

            $('#filtermodal').modal('show');
            $scope.IsHideCost = false;
        }

        $scope.init();

        $scope.PageName = "General Ledger PDC";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }



        $scope.treelistOptions = {
            dataSource: {
                transport: {
                    read: function (o) {
                        MainService.AccountsInKendoTree().then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success([]);
                            toastr.error("NetworkError");
                        })
                    },
                },
                schema: {
                    model: {
                        id: "Id",
                        parentId: "ParentId",
                        fields: {
                            ParentId: {
                                field: "ParentId",
                                nullable: true
                            },
                            Name: {
                                field: "Name",
                                type: "string"
                            },
                            AccountCode: {
                                field: "AccountCode",
                                type: "string"
                            },
                            "AccountType.Name": {
                                //field: "AccountCode",
                                type: "string"
                            }
                        },
                        expanded: true,
                    }
                },
                serverFiltering: false,
            },

            editable: false,
            height: 400,
            sortable: true,
            filterable: {
                mode: "row"
            },
            pageable: {
                pageSize: 50,
                pageSizes: true
            },
            columns: [

                {
                    field: "AccountCode",
                    title: "Account Code",
                },
                {
                    field: "Name",
                    title: "Name",
                },
                {
                    field: "AccountType.Name",
                    title: "Account Type",
                },
                {
                    headerTemplate: "<input  style='margin-left:5px'  type='checkbox' ng-model='selectAllAccRows' ng-click='selectAllAccounts(this)'/>",
                    template: "<input style='margin-left:10px' type='checkbox'  kendo-select={{dataItem.selected}} ng-model='dataItem.checked' ng-change='selectAccountsHead(dataItem)' />",
                    width: "40px"
                },

            ],
        };



        $scope.selectAllAccounts = function (ele) {
            $scope.selectAllAccRows = !$scope.selectAllAccRows;
            if ($scope.selectAllAccRows) {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = true;
                })
            } else {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = false;
                })
            }
            var grid = $scope.ktl;
            if ($scope.selectAllAccRows) {
                grid.table.find("tr").addClass("k-state-selected");
            } else {
                grid.table.find("tr").removeClass("k-state-selected");
            }
        }


        $scope.selectAccountsHead = function (data) {
            //data.checked = !data.checked;
            var rows = $scope.ktl.dataSource.data();
            var tt = data.checked;
            if (tt) {

                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = true;
                        $scope.selectAccountsHead(e);
                    }
                })

            } else {
                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = false;
                        $scope.selectAccountsHead(e);
                    }
                })
            }

        }

        $scope.searchAcc = function () {

            $scope.ktl.options.dataSource.schema.model.expanded = true;
            $scope.ktl.dataSource.filter({
                field: "Name",
                operator: "contains",
                value: $scope.AccFilter.Keyword
            });
            $scope.ktl.dataSource.read();


        }

        $scope.resetAcc = function () {
            $scope.ktl.dataSource.filter({});
            $scope.ktl.options.dataSource.schema.model.expanded = false;
            $scope.ktl.setDataSource($scope.ktl.options.dataSource);
        }


        $scope.Filter = function () {
            $scope.filter.Accounts = $scope.SelectedAccounts;
            $scope.filter.IsFilter = true;
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
            $('#filtermodal').modal('hide');
        }

        $scope.FilterData = function () {
            $('#filtermodal').modal('show');
        }

        $scope.Reset = function () {
            $scope.init();
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        }


        $scope.totalBalance = "0";
        $scope.glGridDataSource = new kendo.data.DataSource({
            page: 1,
            pageSize: 100,
            transport: {
                read: function (o) {
                    if ($scope.filter != null && $scope.filter != undefined) {


                        o.data.IsFilter = $scope.filter.IsFilter;
                        o.data.FromDate = $scope.filter.FromDate;
                        o.data.ToDate = $scope.filter.ToDate;
                        o.data.DocNo = $scope.filter.DocNo;
                        o.data.IsLedgerPDC = true;

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        if ($scope.filter.IsFilter == true) {

                            var accList = $scope.ktl.dataSource.view();

                            //                            var accList = $.grep($scope.ktl.dataSource.data(), function (e) {
                            //                                return e.checked;
                            //                            })

                            var accIds = [];
                            angular.forEach(accList, function (e) {
                                if (e.IsGroup == false && e.checked) {
                                    accIds.push(e.Id);
                                }
                            })

                            console.log(accIds);

                            o.data.Accounts = accIds;
                            var data = JSON.stringify(o.data);



                            $http.post(config.basePath + "GLInView", data).then(function (response) {
                                var data = {
                                    Data: response.data.Data,
                                    Total: response.data.Total,
                                    pageSize: 100,
                                    TotalBalance: response.data.TotalBalance
                                };
                                $scope.GlData = response.data.Data;
                                $scope.totalBalance = kendo.toString(response.data.TotalBalance, '0.00');
                                o.success(data);

                                // Virtual scrollbar height issues fixes
                                window.setTimeout(function () {
                                    var ht = 0;
                                    $('#gl-master-grid').find("tr[role='row']").each(function () {
                                        ht += parseInt($(this).height());
                                    });
                                    // ht - total rows height
                                    $("#gl-master-grid").find(".k-scrollbar-vertical").find("div").height(ht); /// set kendo scrollbar height to ht 

                                    //                                    var grid = $("#gl-master-grid").data("kendoGrid");
                                    //                                    grid.refresh();
                                }, 1000);

                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Some Error Occured");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    } else {
                        o.success({
                            Data: []
                        });
                    }
                }
            },
            schema: {
                data: "Data",
                total: "Total",
                model: {
                    id: "Id",
                    fields: {
                        "Account.Name": {
                            type: "string",
                        },
                        "RefAccount.Name": {
                            type: "string",
                        },
                        AccountId: {
                            type: "number",
                        },
                        Remarks: {
                            type: "string",
                        },
                        PDCType: {
                            type: "string",
                        },
                        Type: {
                            type: "string",
                        },
                        Debit: {
                            type: "number",
                        },
                        Credit: {
                            type: "number",
                        },
                        BalanceAmount: {
                            type: "number",
                            cellFilter: 'number: 2'
                        },
                        Date: {
                            type: "date",
                        },
                        VoucherNumber: {
                            type: "string",
                        },
                    },
                }
            },
            group: [{
                field: "Account.Name",
                aggregates: [
                    {
                        field: "Debit",
                        aggregate: "sum"
                    },
                    {
                        field: "Credit",
                        aggregate: "sum"
                    }
                ]
            },
            {
                field: "PDCType",
                aggregates: [
                    {
                        field: "Debit",
                        aggregate: "sum"
                    },
                    {
                        field: "Credit",
                        aggregate: "sum"
                    }
                ]
            }],
            aggregate: [{
                field: "Debit",
                aggregate: "sum"
            },
            {
                field: "Credit",
                aggregate: "sum"
            }
            ],
            serverPaging: false,
            serverSorting: false,
            serverFiltering: false,
        });
        $scope.glGridOptions = {
            stretch: true,
            toolbar: ["excel", "pdf"],
            excel: {
                allPages: true, // Export all data
                //                fileName: "KendoGridData.xlsx"
            },
            dataBound: onDataBound,
            selectable: true,
            editable: false,
            pageable: true,
            height: 780,
            resizable: true,
            dataSource: $scope.glGridDataSource,
            pageSize: 100,
            pageable: {
                input: false,
                refresh: true,
                pageSizes: true,
                info: true,
            },
            sortable: true,
            scrollable: {
                virtual: true
            },
            filterable: true,
            groupable: false,
            columnMenu: {
                filterable: false,
                filterable: true,
            },
            columns: [
                {
                    field: "Account.Name",
                    hidden: true,
                    groupHeaderTemplate: "Account : #= value # ",
                },

                {
                    field: "PDCType",
                    hidden: true,
                    groupHeaderTemplate: " #= value # ",
                },
                {
                    field: "Date",
                    title: "Date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    headerTemplate: "{{LanguageData.date}}",
                },
                {
                    field: "VoucherNumber",
                    title: "Voucher #",
                    headerTemplate: "{{LanguageData.voucher}}",
                },
                {
                    field: "Type",
                    title: "Type",
                    width: "200px",
                    headerTemplate: "{{LanguageData.type}}",
                },
                {
                    field: "RefAccount.Name",
                    title: "Account",
                    width: "200px",
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    width: "300px",
                    headerTemplate: "{{LanguageData.remarks}}",
                },
                {
                    field: "Debit",
                    title: "Debit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "Debit: #=kendo.toString(sum, 'n')#",
                    headerTemplate: "{{LanguageData.debit}}",
                },
                {
                    field: "Credit",
                    title: "Credit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "Credit: #=kendo.toString(sum, 'n')#",
                    headerTemplate: "{{LanguageData.credit}}",
                },
                {
                    field: "BalanceAmount",
                    title: "Balance",
                    template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                    //groupFooterTemplate: "Balance: #=kendo.toString(sum, '0.00')#",
                    groupFooterTemplate: function (data) {
                        console.log("groupFooterTemplate", data)
                        var items = data.group ? data.group.items : data.items;
                        if (items && items.length > 0) {
                            var balanceAmount = items[items.length - 1].BalanceAmount;

                            // Handle Balance Amount for subgroups
                            if (!balanceAmount) {
                                balanceAmount = 0;
                                for (var i = 0; i < items.length; i++) {
                                    var item = items[i];
                                    if (item.items && item.items.length > 0) {
                                        balanceAmount += item.items[item.items.length - 1].BalanceAmount;
                                    }
                                }
                            }

                            return "Balance: " + kendo.toString(balanceAmount, '0.00');
                        }
                        return "";
                    },
                    //                                        footerTemplate: "Balance: {{totalBalance}}",
                    footerTemplate: function (data) {
                        console.log("footerTemplate", data);
                        return "Balance: " + $scope.totalBalance;
                    },
                    headerTemplate: "{{LanguageData.balance}}",
                }
            ]
        };

        function customFooter(data) {
            console.log(data);
            return 1;
        }

        function onDataBound() {
            console.log("onDataBound");

            var grid = this;
            grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                grid = $("#gl-master-grid").data("kendoGrid");
                var selectedData = grid.dataItem(grid.select());
                $scope.goLegerVoucher(selectedData);
            })
        }

        $scope.printLedger = function () {

            $scope.filter.IsFilter = $scope.filter.IsFilter;
            $scope.filter.FromDate = $scope.filter.FromDate;
            $scope.filter.ToDate = $scope.filter.ToDate;
            $scope.filter.DocNo = $scope.filter.DocNo;

            $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

            $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();


            var accList = $.grep($scope.ktl.dataSource.data(), function (e) {
                return e.checked;
            })

            var accIds = [];
            angular.forEach(accList, function (e) {
                if (e.IsGroup == false) {
                    accIds.push(e.Id);
                }
            })

            console.log(accIds);

            $scope.filter.Accounts = accIds;

            $.LoadingOverlay("show", {
                image: "images/load.gif",
            });


            MainService.PrintGeneralLedgerReport($scope.filter).then(function (response) {
                if (response.data != null) {
                    $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                } else {
                    toastr.error("Network Error");
                }
                $scope.Load = false;
                $.LoadingOverlay("hide");
            }, function (err) {
                toastr.error("Network Error");
                $scope.Load = false;
                $.LoadingOverlay("hide");
            })
        }


        //        $scope.GLData = {};
        //        $scope.VoucherData = {};
        //        $scope.GetVoucherDetailsInGL = function () {
        //
        //            $scope.VoucherData = {};
        //
        //            grid = $("#gl-master-grid").data("kendoGrid");
        //            $scope.GLData = grid.dataItem(grid.select());
        //
        //            alert("123");
        //
        //        }
        //        $scope.RecalculateAllAccounts = function () {
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAllAccounts().then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }
        //
        //        $scope.RecalculateAccountById = function (data) {
        //            console.log(data)
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAccountById(data.items[0].AccountId).then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }

        $scope.goLegerVoucher = function (selectedData) {

            console.log(selectedData)

            if (selectedData.Type == "Sales Invoice") {

                var url = $state.href('editSalesInvoice', {
                    VoucherId: selectedData.SalesInvoiceId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Sales Invoice 2") {

                var url = $state.href('editSalesInvoice2', {
                    VoucherId: selectedData.SalesInvoice2Id
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Sales Invoice 3") {

                var url = $state.href('editSalesInvoice3', {
                    VoucherId: selectedData.SalesInvoice3Id
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Sales Invoice 4") {

                var url = $state.href('editSalesInvoice4', {
                    VoucherId: selectedData.SalesInvoice4Id
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Sales Return") {

                var url = $state.href('editSalesReturn', {
                    VoucherId: selectedData.SalesReturnId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Credit Note SR") {

                var url = $state.href('editCreditNoteSR', {
                    VoucherId: selectedData.CreditNoteSRId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Purchase Invoice") {

                var url = $state.href('editPurchaseInvoice', {
                    VoucherId: selectedData.PurchaseInvoiceId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Purchase Return") {
                var url = $state.href('editPurchaseReturn', {
                    VoucherId: selectedData.PurchaseReturnId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Opening Balance") {

                var url = $state.href('editOpeningBalance', {
                    VoucherId: selectedData.OpeningBalanceId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Fund Payment Voucher") {

                var url = $state.href('editFPVMaster', {
                    VoucherId: selectedData.FPVId
                });
                $window.open(url, '_blank');



            } else if (selectedData.Type == "Fund Receipt Voucher") {

                var url = $state.href('editFRVMaster', {
                    VoucherId: selectedData.FRVId
                });
                $window.open(url, '_blank');



            } else if (selectedData.Type == "Cash Payment Voucher") {

                var url = $state.href('editCPVMaster', {
                    VoucherId: selectedData.CPVId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Cash Receipt Voucher") {

                var url = $state.href('editCRVMaster', {
                    VoucherId: selectedData.CRVId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Cheque Payment Voucher") {

                var url = $state.href('editChequePVMaster', {
                    VoucherId: selectedData.ChequePaymentId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Cheque Receipt Voucher") {

                var url = $state.href('editChequeRVMaster', {
                    VoucherId: selectedData.ChequeReceiptId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Journal Voucher") {

                var url = $state.href('editJVMaster', {
                    VoucherId: selectedData.JVId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "PDC") {

                //                var url = $state.href('editFRVMaster', {
                //                    VoucherId: selectedData.FRVId
                //                });
                //                $window.open(url, '_blank');
                //


                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.PDCId
                //                })
            } else if (selectedData.Type == "Company Expense") {

                var url = $state.href('editcompanyExpense', {
                    VoucherId: selectedData.CompanyExpenseId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Counter Sales") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.
                //                })
            }
            //            if (selectedData.Type == "Contract Invoice") {
            //                $state.go("editPurchaseInvoice", {
            //                    VoucherId: selectedData.
            //                })
            //            }
            else if (selectedData.Type == "Direct Sales Invoice") {
                var url = $state.href('editDirSalesInvoice', {
                    VoucherId: selectedData.DirSalesInvoiceId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Direct Purchase Invoice") {
                var url = $state.href('editDirPurchaseInvoice', {
                    VoucherId: selectedData.DirPurchaseInvoiceId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Export Sales Invoice") {

                var url = $state.href('editExpSalesInvoice', {
                    VoucherId: selectedData.ExpSalesInvoiceId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Export Purchase Invoice") {

                var url = $state.href('editExpPurchaseInvoice', {
                    VoucherId: selectedData.ExpPurchaseInvoiceId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Import Purchase Invoice") {

                var url = $state.href('editImpPurchaseInvoice', {
                    VoucherId: selectedData.ImpPurchaseInvoiceId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Opening Stock") {

                var url = $state.href('editOpeningStock', {
                    VoucherId: selectedData.OpeningStockId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Stock Issue") {

                var url = $state.href('editStockIssue', {
                    VoucherId: selectedData.StockIssueId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Stock FOC") {

                var url = $state.href('editStockFOC', {
                    VoucherId: selectedData.StockFOCId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Stock Receive") {

                var url = $state.href('editStockRecieve', {
                    VoucherId: selectedData.StockReceiveId
                });
                $window.open(url, '_blank');



            } else if (selectedData.Type == "Credit Note") {

                var url = $state.href('editCreditNote', {
                    VoucherId: selectedData.CreditNoteId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Debit Note") {

                var url = $state.href('editDebitNote', {
                    VoucherId: selectedData.DebitNoteId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Stock JV") {

                var url = $state.href('editStockJV', {
                    VoucherId: selectedData.StockJVId
                });
                $window.open(url, '_blank');


            } else if (selectedData.Type == "Individual Sales Invoice") {

                var url = $state.href('editIndSalesInvoice', {
                    VoucherId: selectedData.IndSalesInvoiceId
                });
                $window.open(url, '_blank');

            } else if (selectedData.Type == "Individual Purchase Invoice") {

                var url = $state.href('editIndPurchaseInvoice', {
                    VoucherId: selectedData.IndPurchaseInvoiceId
                });
                $window.open(url, '_blank');

            }
        }



    }]);
